import { ReactElement, useMemo } from 'react';

import { NameDropdown, NameInput } from 'pages/audience/shared/save/components/slideout/components/name/components';
import { useIsAudience, useIsExisting } from 'pages/audience/shared/save/hooks';
import { useSaveStoreSelector } from 'pages/audience/shared/save/hooks/context';

export const useAudienceNameConfiguration = () => {
  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  const isAudience = useIsAudience();
  const isExisting = useIsExisting();
  const component: ReactElement = useMemo(() => {
    if (isAudience) {
      return <NameInput />;
    }

    if (isExisting && !saveTo) {
      return <NameInput />;
    }

    return saveTo ? <NameDropdown /> : <NameInput />;
  }, [isAudience, isExisting, saveTo]);

  return {
    component,
  };
};
